export default {
  to: "Aan: {{name}} <{{email}}>",

  attachment: {
    label: "Bijlagen: ",
    pdf: "{{number}}.pdf",
  },

  subject: {
    label: "Onderwerp",
    value: "HERINNERING FACTUUR {{number}} | {{clientName}}"
  },

  dueDate: {
    label: "Herinnering verloop datum",
  },

  message: {
    label: "Bericht: ",
  },

  button: {
    send: "Verstuur herinnering",
    cancel: "Annuleren",
  }
}
